
import React from 'react';
import { Link } from 'react-router-dom';
import Lottie from 'lottie-react';

interface NavIconProps {
  icon: string;
  label: string;
  to: string;
  isLottie?: boolean;
}

const NavIcon: React.FC<NavIconProps> = ({ icon, label, to, isLottie = false }) => {
  const [lottieData, setLottieData] = React.useState(null);

  React.useEffect(() => {
    if (isLottie) {
      // Dynamically import the Lottie JSON file
      fetch(icon)
        .then(response => response.json())
        .then(data => setLottieData(data))
        .catch(error => console.error("Failed to load Lottie animation:", error));
    }
  }, [icon, isLottie]);

  return (
    <Link 
      to={to}
      className="card-neo p-4 flex flex-col items-center justify-center text-center hover-scale"
    >
      <div className="w-12 h-12 mb-2">
        {isLottie && lottieData ? (
          <Lottie 
            animationData={lottieData} 
            loop={true} 
            autoplay={true}
          />
        ) : (
          <img src={icon} alt={label} className="w-full h-full object-contain" />
        )}
      </div>
      <span className="text-sm font-medium">{label}</span>
    </Link>
  );
};

export default NavIcon;
